<div class="valuation-page">
    <div class="container">
        <!-- Logo Header -->
        <!-- <header class="logo-header">
            <a routerLink="/home">
                <img src="./assets/images/logo.png" alt="Bajaj Capital Logo" class="main-logo">
            </a>
        </header> -->

        <main class="content-wrapper">
            <div class="row align-items-center">
                <!-- Left Content -->
                <div class="col-lg-6 left-section">
                    <h1 class="main-heading">Other Valuations <br>and Certifications</h1>

                    <div class="description">
                        <p>Our practise includes pertinent valuations and certifications for the purposes of RBI, Income
                            Tax etc.</p>
                        <p>Business Valuation is another focus area of our consultation.</p>
                    </div>

                    <div class="query-section">
                        <p class="query-text">For queries, feedback and grievances, please write to</p>
                        <a href="mailto:information@bajajcapitalsec.com" class="email-btn">
                            <i class="fas fa-envelope"></i>
                            information@bajajcapitalsec.com
                        </a>
                    </div>
                </div>

                <!-- Right Image -->
                <div class="col-lg-6 right-section">
                    <div class="image-container">
                        <img src="./assets/images/valuations.png" alt="Professional Meeting" class="valuation-image">
                    </div>
                </div>
            </div>
        </main>
    </div>
</div>